import { render, staticRenderFns } from "./DummySpan.vue?vue&type=template&id=e1d3c2c0&"
import script from "./DummySpan.vue?vue&type=script&lang=ts&"
export * from "./DummySpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports